import * as React from 'react';
import shouldFlipBG from '../utils/should-flip-bg';
import '../css/toggle-switch.sass';

interface ToggleSwitchProps {
  name: string;
  label: string;
  value: string;
  id: string;
  checked?: boolean;
  focus?: boolean;
  onChange?: Function;
  onBlur?: Function;
  theme?: 'night' | 'day';
  disabled?: boolean;
  transparent?: boolean;
}
interface ToggleSwitchState {
  flipBg: string;
}

export default function ToggleSwitch(props: ToggleSwitchProps) {
  const inputEl: any = React.useRef(null);
  const { theme = 'day' } = props;
  const inputElParent: any = React.useRef(null);

  React.useEffect(() => {
    if (props.focus && inputEl && inputEl.current) {
      inputEl.current.focus();
    }
  }, [props.focus]);

  const [state, setState] = React.useState<ToggleSwitchState>({
    flipBg: '',
  });

  const handleMouseDown = () => {
    if (inputElParent.current) {
      inputElParent.current.classList.add('using-mouse');
    }
  };

  const handleKeyDown = (e: any) => {
    if (inputElParent.current) {
      if (e.keyCode === 9) {
        inputElParent.current.classList.remove('using-mouse');
      }
    }
  };

  React.useEffect(() => {
    document.addEventListener('mousedown', handleMouseDown);
    document.addEventListener('keydown', handleKeyDown);
  }, [props]);

  React.useEffect(() => {
    if (state.flipBg === '' && shouldFlipBG(inputElParent, theme)) {
      setState({
        ...state,
        flipBg: ' flipbg',
      });
    }
  }, []);

  return (
    <div
      ref={inputElParent}
      className={`input-field toggle-switch ${theme}${state.flipBg}${
        props.disabled ? ' disabled' : ''
      }${props.transparent ? ' transparent' : ''}
         `}
    >
      <div className="text">
        {props.label && (
          <label
            className={`value ${props.checked ? 'checked' : ''}`}
            htmlFor={props.id}
          >
            {props.label}
          </label>
        )}
      </div>
      <div>
        <label className="switch">
          <input
            type="checkbox"
            value={props.value}
            id={props.id}
            className={theme}
            name={props.name}
            ref={inputEl}
            onKeyDown={(e: any) => {
              if (props.onChange !== undefined && e.keyCode === 13) {
                props.onChange({
                  target: {
                    value: e.target.value,
                  },
                });
              }
            }}
            checked={props.checked}
            disabled={props.disabled}
            onBlur={(e: any) => {
              if (props.onBlur !== undefined) {
                props.onBlur(e);
              }
            }}
            onChange={(e: any) => {
              if (props.onChange !== undefined) {
                props.onChange(e);
              }
            }}
          />
          <span className="slider round" />
        </label>
      </div>
    </div>
  );
}
